import {UNIT} from '@di-shared/const';
import React from 'react';
import {Trans} from 'react-i18next';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import useUnitConverter from '@di-shared/utils/useUnitConverter';

function UbiContentsLoading() {
  const {t} = useInferableTranslation();
  const {defaultDistanceSymbol} = useUnitConverter();
  return (
    <main className="content page_ubi">
      <section className="section">
        <div className="section_heading type_main skeleton">
          <h2
            className="section_heading_title"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('T20020')}
          </h2>
        </div>
        <div className="section_container skeleton">
          <div className="ubi_my">
            <ul className="ubi_my_list">
              <li className="ubi_my_item">
                <span className="ubi_my_key">{t('T20021')}</span>
                <span className="ubi_my_val">{t('T20006_$score', {score: 99})}</span>
              </li>
              <li className="ubi_my_item">
                <span className="ubi_my_key">{t('T20022')}</span>
                <span className="ubi_my_val">
                  1000
                  {defaultDistanceSymbol}
                </span>
              </li>
            </ul>
            <div className="section_container_box">
              <span
                className="ubi_my_notice_title"
                style={{whiteSpace: 'pre-wrap'}}
              >
                4점 더 높이면 25.2% 할인 받으실 수 있어요.
              </span>
              <span
                className={'ubi_my_notice_desc'}
                style={{whiteSpace: 'pre-wrap'}}
              >
                지금 점수로는 12.2%를 할인받을 수 있어요.
              </span>
            </div>
          </div>
        </div>

        <ul className="insurance_list skeleton">
          <li className="insurance_item">
            <div className="insurance_logo"></div>
            <div className="insurance_info">
              <p className="insurance_title">하나손해보험</p>
              <div className="badge_box">
                <span className="badge badge_outline">
                  <Trans
                    i18nKey={'T20024_$discount'}
                    values={{discount: 50}}
                    components={{
                      Highlighted: <span className="text_emphasis" />,
                    }}
                  />
                </span>
                <span className="badge badge_outline">
                  <Trans
                    i18nKey={'T20026_$discount'}
                    values={{discount: 60}}
                    components={{
                      Highlighted: <span className="text_emphasis" />,
                    }}
                  />
                </span>
              </div>
            </div>
            <div className="insurance_rate">
              <span className="insurance_rate_percent">
                99
                {UNIT.PERCENT}
              </span>
              <span className="insurance_rate_txt">{t('T20027')}</span>
            </div>
          </li>
          <li className="insurance_item">
            <div className="insurance_logo"></div>
            <div className="insurance_info">
              <p className="insurance_title">하나손해보험</p>
              <div className="badge_box">
                <span className="badge badge_outline">
                  <Trans
                    i18nKey={'T20024_$discount'}
                    values={{discount: 50}}
                    components={{
                      Highlighted: <span className="text_emphasis" />,
                    }}
                  />
                </span>
                <span className="badge badge_outline">
                  <Trans
                    i18nKey={'T20026_$discount'}
                    values={{discount: 60}}
                    components={{
                      Highlighted: <span className="text_emphasis" />,
                    }}
                  />
                </span>
              </div>
            </div>
            <div className="insurance_rate">
              <span className="insurance_rate_percent">
                99
                {UNIT.PERCENT}
              </span>
              <span className="insurance_rate_txt">{t('T20027')}</span>
            </div>
          </li>
          <li className="insurance_item">
            <div className="insurance_logo"></div>
            <div className="insurance_info">
              <p className="insurance_title">하나손해보험</p>
              <div className="badge_box">
                <span className="badge badge_outline">
                  <Trans
                    i18nKey={'T20024_$discount'}
                    values={{discount: 50}}
                    components={{
                      Highlighted: <span className="text_emphasis" />,
                    }}
                  />
                </span>
                <span className="badge badge_outline">
                  <Trans
                    i18nKey={'T20026_$discount'}
                    values={{discount: 60}}
                    components={{
                      Highlighted: <span className="text_emphasis" />,
                    }}
                  />
                </span>
              </div>
            </div>
            <div className="insurance_rate">
              <span className="insurance_rate_percent">
                99
                {UNIT.PERCENT}
              </span>
              <span className="insurance_rate_txt">{t('T20027')}</span>
            </div>
          </li>
          <li className="insurance_item">
            <div className="insurance_logo"></div>
            <div className="insurance_info">
              <p className="insurance_title">하나손해보험</p>
              <div className="badge_box">
                <span className="badge badge_outline">
                  <Trans
                    i18nKey={'T20024_$discount'}
                    values={{discount: 50}}
                    components={{
                      Highlighted: <span className="text_emphasis" />,
                    }}
                  />
                </span>
                <span className="badge badge_outline">
                  <Trans
                    i18nKey={'T20026_$discount'}
                    values={{discount: 60}}
                    components={{
                      Highlighted: <span className="text_emphasis" />,
                    }}
                  />
                </span>
              </div>
            </div>
            <div className="insurance_rate">
              <span className="insurance_rate_percent">
                99
                {UNIT.PERCENT}
              </span>
              <span className="insurance_rate_txt">{t('T20027')}</span>
            </div>
          </li>
        </ul>
      </section>
    </main>
  );
}

export default UbiContentsLoading;
